import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserRoleEnum } from 'enums'
import { RootState } from 'store'

export type UserSlice = {
  id: number
  email: string
  role: UserRoleEnum
  firstName: string
  lastName: string
  phone: string
  address: string
  tenantId?: number
  logo: string
}

const initialState = {} as UserSlice

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserSlice>) => {
      return action.payload
    },
    clearUser: () => {
      return {} as UserSlice
    },
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload
    },
    setFirstName: (state, action: PayloadAction<string>) => {
      state.firstName = action.payload
    },
    setLastName: (state, action: PayloadAction<string>) => {
      state.lastName = action.payload
    },
    setPhone: (state, action: PayloadAction<string>) => {
      state.phone = action.payload
    },
    setAddress: (state, action: PayloadAction<string>) => {
      state.address = action.payload
    },
    setLogo: (state, action: PayloadAction<string>) => {
      state.logo = action.payload
    },
  },
})

export const selectUser = (state: RootState) => state.user
export const userSelectors = {
  selectFirstName: (state: RootState) => state.user.firstName,
  selectLastName: (state: RootState) => state.user.lastName,
  selectEmail: (state: RootState) => state.user.email,
  selectPhone: (state: RootState) => state.user.phone,
  selectRole: (state: RootState) => state.user.role,
  selectAddress: (state: RootState) => state.user.address,
  selectLogo: (state: RootState) => state.user.logo,
}

export const { clearUser, setAddress, setEmail, setFirstName, setLastName, setPhone, setUser, setLogo } =
  userSlice.actions

export const userReducer = userSlice.reducer

export default userSlice.reducer
